import { DateInput } from "@blueprintjs/datetime"
import dayjs from "dayjs"
import customFormat from "dayjs/plugin/customParseFormat"
import React from "react"
import { RuleStrType } from "."
import RuleWrapper, { RuleWrapperType } from "./RuleWrapper"

dayjs.extend(customFormat)

type SingleDateType = RuleWrapperType & {
  ruleType: {
    rule: Date
    type: RuleStrType
  }
  onChange?: (rule: Date) => void
}
const SingleDate = ({ ruleType, onChange, ...props }: SingleDateType) => {
  const rule = ruleType.rule

  return (
    <RuleWrapper
      {...props}
      ruleType={ruleType.type}
      title={dayjs(rule).format("dddd, Do MMM YYYY")}
    >
      <DateInput
        maxDate={dayjs().add(5, "year").toDate()}
        formatDate={date => dayjs(date).format("DD/DD/YYYY")}
        inputProps={{ leftIcon: "calendar" }}
        value={rule}
        onChange={onChange}
      />
    </RuleWrapper>
  )
}

export default SingleDate
